<script setup> 
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { ref, computed, onMounted, watch } from 'vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Head } from '@inertiajs/inertia-vue3';
import {
    mdiFormatFontSizeDecrease, mdiContrastCircle, mdiCheckCircle,
    mdiAlert,
    mdiAlertCircle,
    mdiMagnify,
    mdiDownloadBox,
    mdiPaperclip
} from '@mdi/js';
import axios from 'axios';
import QRCode from 'qrcode';
import { Icon } from '@iconify/vue';
import NotificationBar from "@/Components/NotificationBar.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import BaseIcon from "@/Components/BaseIcon.vue";
import CardBox from "@/Components/CardBox.vue";
import TableFiles from "@/Components/TableFiles.vue";
import Alert from "@/Components/Alert.vue";

const props = defineProps({
    constantCompany: Array,
});

const data = {
    "files": [
        { "id": 1, "type": "file-pdf", "note": "Reglamento interno del alumno" },
        { "id": 2, "type": "file-pdf", "note": "Manuales de uso del sistema" },
        { "id": 3, "type": "file-pdf", "note": "Carta del director" },
        { "id": 3, "type": "file-img", "note": "Códigos de excel" },

    ]
};

const rutaPrefijo = ref('constante');

const errors = {};
const mensajes = ref([]);
const fileSubida = ref('');
const alertaSubida = ref(0);

const eventSubirArchivo = (rutaController) => {
    let formData = new FormData();
    formData.append('file', fileSubida.value);
    axios.post(rutaController,
        formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    ).then(function (response) {
        let respuesta = response;
        let data = respuesta.data.data;
        if (respuesta.data.success) {
            alertaSubida.value = 1;
            mensajes.value = 'Total registros : ' + (data.total - 1) + '\nRegistrados : ' + data.registered + '\nActualizados : ' + data.updated;
            limpiarVal(5000);

        } else {
            alertaSubida.value = 2;
            mensajes.value = respuesta.data.message;
            limpiarVal(3000);
        }
    }).catch(function () {
        alertaSubida.value = 2;
        limpiarVal(3000);
    });
}

const handleFileUploadArchivo = (event) => {
    fileSubida.value = event.target.files[0];
}

const limpiarVal = (time) => {
    setTimeout(() => {
        fileSubida.value = '';
        mensajes.value = [];
        alertaSubida.value = 0;
    }, time)
}

// Alert
const notificationSettingsModel = ref([]);
const notificationsOutline = computed(
    () => notificationSettingsModel.value.indexOf("outline") > -1
);

// Photo Previews
const logoInput = ref(null);
const faviconInput = ref(null);
const logoPreview = ref(null);
const faviconPreview = ref(null);
const logoFile = ref(null);
const faviconFile = ref(null);

// Hero Image
const heroInput = ref(null);
const heroPreview = ref('/img/hero.png');
const isDefaultHero = ref(true);
const heroFile = ref(null);

// Welcome Content & QR Link
const contentWelcome = ref('');
const appUrlQr = ref('');
const qrDataUrl = ref('');
const activeTabWelcome = ref('editor'); // 'editor' | 'preview'

// QR Image Upload (opcional si se sube una personalizada)
const qrInput = ref(null);
const qrCustomPreview = ref(null);
const qrCustomFile = ref(null);

const isAlertShow = ref(false);
const alertMessage = ref('');
const isSaving = ref(false);

const triggerLogoUpload = () => {
    logoInput.value.click();
};

const triggerFaviconUpload = () => {
    faviconInput.value.click();
};

const triggerHeroUpload = () => {
    heroInput.value.click();
};

const triggerQrUpload = () => {
    qrInput.value.click();
};

const generateQr = async () => {
    const url = appUrlQr.value ? appUrlQr.value : window.location.origin;
    try {
        qrDataUrl.value = await QRCode.toDataURL(url, {
            width: 220,
            margin: 2,
            color: {
                dark: '#0f172a',
                light: '#ffffff'
            }
        });
    } catch (err) {
        console.error('Error generando QR:', err);
    }
};

watch(appUrlQr, () => {
    generateQr();
});

const uploadImage = async (file, type) => {
    let formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);

    try {
        const response = await axios.post('/config/company/upload-logo', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        if (response.data.success) {
            return response.data.path;
        }
    } catch (error) {
        console.error(error);
    }
    return null;
};

const handleLogoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
        logoPreview.value = URL.createObjectURL(file);
        logoFile.value = file;
    }
};

const handleFaviconChange = (event) => {
    const file = event.target.files[0];
    if (file) {
        faviconPreview.value = URL.createObjectURL(file);
        faviconFile.value = file;
    }
};

const handleHeroChange = (event) => {
    const file = event.target.files[0];
    if (file) {
        heroPreview.value = URL.createObjectURL(file);
        heroFile.value = file;
        isDefaultHero.value = false;
    }
};

const handleQrChange = (event) => {
    const file = event.target.files[0];
    if (file) {
        qrCustomPreview.value = URL.createObjectURL(file);
        qrCustomFile.value = file;
    }
};

const resetLogo = () => {
    logoPreview.value = null;
    logoFile.value = null;
    if (logoInput.value) logoInput.value.value = '';
};

const resetFavicon = () => {
    faviconPreview.value = null;
    faviconFile.value = null;
    if (faviconInput.value) faviconInput.value.value = '';
};

const resetHero = async () => {
    try {
        const response = await axios.post('/config/company/upload-hero', { reset: true });
        if (response.data.success) {
            heroPreview.value = '/img/hero.png';
            heroFile.value = null;
            isDefaultHero.value = true;
            if (heroInput.value) heroInput.value.value = '';
            alertMessage.value = response.data.message;
            isAlertShow.value = true;
            setTimeout(() => isAlertShow.value = false, 3500);
        }
    } catch (e) {
        console.error(e);
    }
};

const resetQrCustom = async () => {
    try {
        const response = await axios.post('/config/company/upload-qr', { reset: true });
        if (response.data.success) {
            qrCustomPreview.value = null;
            qrCustomFile.value = null;
            if (qrInput.value) qrInput.value.value = '';
            generateQr();
            alertMessage.value = response.data.message;
            isAlertShow.value = true;
            setTimeout(() => isAlertShow.value = false, 3500);
        }
    } catch (e) {
        console.error(e);
    }
};

const saveChanges = async () => {
    isSaving.value = true;
    let hasError = false;

    // 1. Process Logo
    if (logoFile.value) {
        const path = await uploadImage(logoFile.value, 'LOGO_SVG_FULL');
        if (path) {
            logoPreview.value = path + '?t=' + new Date().getTime();
            logoFile.value = null;
        } else {
            hasError = true;
        }
    }
    
    // 2. Process Favicon
    if (faviconFile.value) {
        const path = await uploadImage(faviconFile.value, 'LOGO_SVG');
        if (path) {
            faviconPreview.value = path + '?t=' + new Date().getTime();
            faviconFile.value = null;
        } else {
            hasError = true;
        }
    }

    // 3. Process Hero image
    if (heroFile.value) {
        let formData = new FormData();
        formData.append('file', heroFile.value);
        try {
            const resp = await axios.post('/config/company/upload-hero', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            if (resp.data.success) {
                heroPreview.value = resp.data.path + '?t=' + new Date().getTime();
                heroFile.value = null;
                isDefaultHero.value = false;
            }
        } catch (e) {
            hasError = true;
        }
    }

    // 4. Process custom QR image if selected
    if (qrCustomFile.value) {
        let formData = new FormData();
        formData.append('file', qrCustomFile.value);
        try {
            const resp = await axios.post('/config/company/upload-qr', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            if (resp.data.success) {
                qrCustomPreview.value = resp.data.path + '?t=' + new Date().getTime();
                qrCustomFile.value = null;
            }
        } catch (e) {
            hasError = true;
        }
    }

    // 5. Save settings (CONTENT_WELCOME, APP_URL_QR)
    try {
        await axios.post('/config/company/save-settings', {
            content_welcome: contentWelcome.value,
            app_url_qr: appUrlQr.value
        });
    } catch (e) {
        hasError = true;
    }

    isSaving.value = false;

    if (!hasError) {
        alertMessage.value = 'Los cambios han sido guardados correctamente.';
        isAlertShow.value = true;
        setTimeout(() => {
            isAlertShow.value = false;
        }, 4000);
    }
};

onMounted(() => {
    if (props.constantCompany) {
        const logo = props.constantCompany.find(c => c.name === 'LOGO_SVG_FULL');
        if (logo && logo.value && logo.value.trim() !== '' && !logo.value.includes('<svg')) {
            logoPreview.value = logo.value;
        }

        const favicon = props.constantCompany.find(c => c.name === 'LOGO_SVG');
        if (favicon && favicon.value && favicon.value.trim() !== '' && !favicon.value.includes('<svg')) {
            faviconPreview.value = favicon.value;
        }

        const hero = props.constantCompany.find(c => c.name === 'HERO_IMG');
        if (hero && hero.value && hero.value.trim() !== '') {
            heroPreview.value = hero.value;
            isDefaultHero.value = false;
        } else {
            heroPreview.value = '/img/hero.png';
            isDefaultHero.value = true;
        }

        const welcome = props.constantCompany.find(c => c.name === 'CONTENT_WELCOME');
        if (welcome && welcome.value) {
            contentWelcome.value = welcome.value;
        }

        const qrUrl = props.constantCompany.find(c => c.name === 'APP_URL_QR');
        if (qrUrl && qrUrl.value) {
            appUrlQr.value = qrUrl.value;
        } else {
            appUrlQr.value = window.location.origin;
        }

        const qrImg = props.constantCompany.find(c => c.name === 'QR_IMAGE');
        if (qrImg && qrImg.value && qrImg.value.trim() !== '') {
            qrCustomPreview.value = qrImg.value;
        }

        generateQr();
    }
});

</script>

<template>

    <Head title="Importación" />

    <BreezeAuthenticatedLayout>
        <template #header>
        <PremiumPageHeader icon="tabler:settings" title="Configuración de Empresa" subtitle="Gestión de configuración de empresa">
        </PremiumPageHeader>
    </template>

        <div>
            <!-- <NotificationBar v-if="alertaSubida == 4" color="contrast" :icon="mdiContrastCircle" :outline="notificationsOutline">
                <b>Contrast</b>. NotificationBar
            </NotificationBar>
            <NotificationBar v-if="alertaSubida == 1" color="success" :icon="mdiCheckCircle" :outline="notificationsOutline">
                <b>Ok</b>. <span v-text="mensajes"></span>
            </NotificationBar>
            <NotificationBar v-if="alertaSubida == 2" color="danger" :icon="mdiAlertCircle" :outline="notificationsOutline">
                <b>Error</b>. <span v-text="mensajes"></span>
            </NotificationBar> -->
            <div class="max-w-6xl mx-auto pb-10">
                <div class="bg-white dark:bg-slate-800 overflow-hidden border border-slate-200 dark:border-slate-700 rounded-xl shadow-sm p-6 lg:p-8">
                    
                    <!-- Headers with Photos & Visuals -->
                    <div class="grid grid-cols-1 xl:grid-cols-2 gap-8 mb-8 pb-8 border-b border-slate-200 dark:border-slate-700">
                        <!-- Logo Upload -->
                        <div class="flex flex-col sm:flex-row sm:items-center gap-6">
                            <div class="w-24 h-24 p-2 rounded-xl bg-slate-100 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 flex items-center justify-center shrink-0 overflow-hidden">
                                <img v-if="logoPreview" :src="logoPreview" class="w-full h-full object-contain" />
                                <Icon v-else icon="tabler:building" class="w-10 h-10 text-slate-400" />
                            </div>
                            <div>
                                <h3 class="text-sm font-bold text-slate-800 dark:text-slate-200 mb-2.5">Logo Principal</h3>
                                <div class="flex flex-wrap items-center gap-3 mb-2">
                                    <input type="file" ref="logoInput" class="hidden" @change="handleLogoChange" accept="image/jpeg, image/png, image/svg+xml" />
                                    <button type="button" @click="triggerLogoUpload" class="bg-[#1f8bed] hover:bg-blue-600 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors shadow-sm">
                                        Subir logo
                                    </button>
                                    <button type="button" @click="resetLogo" class="bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 text-sm font-medium px-4 py-2 rounded-lg transition-colors">
                                        Restablecer
                                    </button>
                                </div>
                                <p class="text-xs text-slate-500 dark:text-slate-400 mt-2">
                                    Permitido JPG, PNG, SVG. Recomendado: formato horizontal. Max 800K.
                                </p>
                            </div>
                        </div>

                        <!-- Favicon Upload -->
                        <div class="flex flex-col sm:flex-row sm:items-center gap-6 xl:pl-8 xl:border-l border-slate-200 dark:border-slate-700">
                            <div class="w-24 h-24 p-2 rounded-xl bg-slate-100 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 flex items-center justify-center shrink-0 overflow-hidden">
                                <img v-if="faviconPreview" :src="faviconPreview" class="w-full h-full object-contain" />
                                <Icon v-else icon="tabler:app-window" class="w-10 h-10 text-slate-400" />
                            </div>
                            <div>
                                <h3 class="text-sm font-bold text-slate-800 dark:text-slate-200 mb-2.5">Ícono (Favicon)</h3>
                                <div class="flex flex-wrap items-center gap-3 mb-2">
                                    <input type="file" ref="faviconInput" class="hidden" @change="handleFaviconChange" accept="image/jpeg, image/png, image/svg+xml" />
                                    <button type="button" @click="triggerFaviconUpload" class="bg-[#1f8bed] hover:bg-blue-600 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors shadow-sm">
                                        Subir ícono
                                    </button>
                                    <button type="button" @click="resetFavicon" class="bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 text-sm font-medium px-4 py-2 rounded-lg transition-colors">
                                        Restablecer
                                    </button>
                                </div>
                                <p class="text-xs text-slate-500 dark:text-slate-400 mt-2">
                                    Permitido JPG, PNG, SVG. Recomendado: 512x512px. Max 200K.
                                </p>
                            </div>
                        </div>

                        <!-- Imagen de Inicio (Hero) -->
                        <div class="flex flex-col sm:flex-row sm:items-center gap-6 pt-6 border-t border-slate-200 dark:border-slate-700">
                            <div class="w-24 h-24 p-2 rounded-xl bg-slate-100 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 flex items-center justify-center shrink-0 overflow-hidden relative group">
                                <img :src="heroPreview" class="w-full h-full object-contain" />
                                <span v-if="isDefaultHero" class="absolute bottom-1 bg-slate-800/80 text-white text-[10px] px-1.5 py-0.5 rounded">Default</span>
                            </div>
                            <div>
                                <h3 class="text-sm font-bold text-slate-800 dark:text-slate-200 mb-2.5 flex items-center gap-2">
                                    Imagen de Inicio (Bienvenida)
                                    <span v-if="!isDefaultHero" class="text-xs bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300 font-semibold px-2 py-0.5 rounded-full">Personalizada</span>
                                </h3>
                                <div class="flex flex-wrap items-center gap-3 mb-2">
                                    <input type="file" ref="heroInput" class="hidden" @change="handleHeroChange" accept="image/jpeg, image/png, image/svg+xml, image/webp" />
                                    <button type="button" @click="triggerHeroUpload" class="bg-[#1f8bed] hover:bg-blue-600 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors shadow-sm">
                                        Subir imagen
                                    </button>
                                    <button type="button" @click="resetHero" class="bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 text-sm font-medium px-4 py-2 rounded-lg transition-colors">
                                        Restablecer
                                    </button>
                                </div>
                                <p class="text-xs text-slate-500 dark:text-slate-400 mt-2">
                                    Ilustración o imagen principal en Welcome.vue. Si no se sube ninguna, se mostrará la que está por defecto.
                                </p>
                            </div>
                        </div>

                        <!-- Código QR / PWA Móvil -->
                        <div class="flex flex-col sm:flex-row sm:items-center gap-6 pt-6 xl:pl-8 border-t xl:border-l border-slate-200 dark:border-slate-700">
                            <div class="w-24 h-24 p-1.5 rounded-xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 flex items-center justify-center shrink-0 overflow-hidden shadow-xs">
                                <img v-if="qrCustomPreview" :src="qrCustomPreview" class="w-full h-full object-contain" />
                                <img v-else-if="qrDataUrl" :src="qrDataUrl" class="w-full h-full object-contain" />
                                <Icon v-else icon="tabler:qrcode" class="w-10 h-10 text-slate-400" />
                            </div>
                            <div>
                                <h3 class="text-sm font-bold text-slate-800 dark:text-slate-200 mb-2.5 flex items-center gap-2">
                                    Código QR (Acceso Móvil / PWA)
                                    <span v-if="qrCustomPreview" class="text-xs bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-300 font-semibold px-2 py-0.5 rounded-full">Imagen manual</span>
                                    <span v-else class="text-xs bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-300 font-semibold px-2 py-0.5 rounded-full">Auto QR</span>
                                </h3>
                                <div class="flex flex-wrap items-center gap-3 mb-2">
                                    <input type="file" ref="qrInput" class="hidden" @change="handleQrChange" accept="image/jpeg, image/png, image/svg+xml, image/webp" />
                                    <button type="button" @click="triggerQrUpload" class="bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 text-sm font-medium px-4 py-2 rounded-lg transition-colors">
                                        Subir QR estático
                                    </button>
                                    <button v-if="qrCustomPreview" type="button" @click="resetQrCustom" class="bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 text-sm font-medium px-4 py-2 rounded-lg transition-colors">
                                        Usar Auto QR
                                    </button>
                                </div>
                                <p class="text-xs text-slate-500 dark:text-slate-400 mt-2">
                                    Se genera automáticamente desde <b>APP_URL_QR</b> o puedes subir un diseño propio de QR.
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Configuración Pantalla Welcome & QR PWA -->
                    <div class="mb-8 pb-8 border-b border-slate-200 dark:border-slate-700 space-y-6">
                        <div class="flex items-center gap-2 pb-2">
                            <Icon icon="tabler:layout-dashboard" class="w-5 h-5 text-[#1f8bed]" />
                            <h2 class="text-base font-bold text-slate-800 dark:text-slate-100">Personalización de Inicio (Welcome & PWA)</h2>
                        </div>

                        <!-- APP_URL_QR Field -->
                        <div>
                            <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                                URL para Generación de QR (PWA Móvil) - <span class="font-mono text-xs text-slate-500">APP_URL_QR</span>
                            </label>
                            <div class="flex gap-2">
                                <div class="relative flex-1">
                                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400">
                                        <Icon icon="tabler:link" class="w-5 h-5" />
                                    </div>
                                    <input 
                                        type="url" 
                                        v-model="appUrlQr" 
                                        class="w-full pl-10" 
                                        placeholder="Ej: https://sistema.unens.com" 
                                    />
                                </div>
                                <a 
                                    v-if="appUrlQr" 
                                    :href="appUrlQr" 
                                    target="_blank" 
                                    class="bg-slate-100 hover:bg-slate-200 text-slate-700 px-4 py-2 rounded-lg text-sm flex items-center gap-1.5 transition-colors"
                                >
                                    <Icon icon="tabler:external-link" class="w-4 h-4" />
                                    Probar
                                </a>
                            </div>
                            <p class="text-xs text-slate-500 mt-1">Este link se codifica en el código QR para que los usuarios abran e instalen la PWA desde su celular.</p>
                        </div>

                        <!-- CONTENT_WELCOME HTML Field -->
                        <div>
                            <div class="flex items-center justify-between mb-2">
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300">
                                    Contenido HTML de Bienvenida - <span class="font-mono text-xs text-slate-500">CONTENT_WELCOME</span>
                                </label>
                                <div class="flex items-center gap-1 bg-slate-100 dark:bg-slate-900 p-1 rounded-lg text-xs font-semibold">
                                    <button 
                                        type="button" 
                                        @click="activeTabWelcome = 'editor'" 
                                        :class="activeTabWelcome === 'editor' ? 'bg-white dark:bg-slate-800 text-[#1f8bed] shadow-xs' : 'text-slate-600 dark:text-slate-400'"
                                        class="px-3 py-1 rounded-md transition-all"
                                    >
                                        Código HTML
                                    </button>
                                    <button 
                                        type="button" 
                                        @click="activeTabWelcome = 'preview'" 
                                        :class="activeTabWelcome === 'preview' ? 'bg-white dark:bg-slate-800 text-[#1f8bed] shadow-xs' : 'text-slate-600 dark:text-slate-400'"
                                        class="px-3 py-1 rounded-md transition-all"
                                    >
                                        Vista previa
                                    </button>
                                </div>
                            </div>

                            <div v-show="activeTabWelcome === 'editor'">
                                <textarea 
                                    v-model="contentWelcome" 
                                    rows="6" 
                                    class="w-full font-mono text-xs md:text-sm bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-700 rounded-lg p-3 text-slate-800 dark:text-slate-200 focus:ring-2 focus:ring-[#1f8bed]/20 focus:border-[#1f8bed]"
                                    placeholder="<div class=&quot;md:w-10/12 w-full&quot;> ... </div>"
                                ></textarea>
                                <div class="flex items-center justify-between mt-1">
                                    <p class="text-xs text-slate-500">Puedes usar etiquetas HTML y clases de Tailwind CSS como <code class="bg-slate-100 px-1 py-0.5 rounded text-rose-600">text-rose-600</code>.</p>
                                </div>
                            </div>

                            <div v-show="activeTabWelcome === 'preview'" class="p-6 bg-slate-50 dark:bg-slate-900/40 rounded-xl border border-slate-200 dark:border-slate-700 min-h-[140px] flex items-center">
                                <div v-if="contentWelcome" v-html="contentWelcome" class="w-full"></div>
                                <div v-else class="text-slate-400 italic text-sm text-center w-full">Sin contenido de bienvenida configurado.</div>
                            </div>
                        </div>
                    </div>

                    <!-- Form Grid -->
                    <form @submit.prevent="">
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                            
                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Nombre de la Institución</label>
                                <input type="text" class="w-full" placeholder="Ej. Colegio San Juan">
                            </div>
                            
                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Razón Social</label>
                                <input type="text" class="w-full" placeholder="Ej. Consorcio Educativo S.A.C.">
                            </div>
                            
                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Correo Electrónico</label>
                                <input type="email" class="w-full" placeholder="contacto@ejemplo.edu.pe">
                            </div>
                            
                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Organización / RUC</label>
                                <input type="text" class="w-full" placeholder="20123456789">
                            </div>
                            
                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Número de Teléfono</label>
                                <div class="flex gap-2">
                                    <select class="w-1/3">
                                        <option>PE (+51)</option>
                                        <option>US (+1)</option>
                                        <option>MX (+52)</option>
                                    </select>
                                    <input type="text" class="flex-1 w-full" placeholder="987 654 321">
                                </div>
                            </div>
                            
                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Dirección</label>
                                <input type="text" class="w-full" placeholder="Av. Principal 123">
                            </div>
                            
                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Departamento / Estado</label>
                                <input type="text" class="w-full" placeholder="Lima">
                            </div>
                            
                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Código Postal</label>
                                <input type="text" class="w-full" placeholder="15001">
                            </div>
                            
                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">País</label>
                                <select class="w-full">
                                    <option value="" disabled selected>Seleccionar País</option>
                                    <option>Perú</option>
                                    <option>Colombia</option>
                                    <option>Chile</option>
                                    <option>Ecuador</option>
                                    <option>México</option>
                                </select>
                            </div>
                            
                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Idioma</label>
                                <select class="w-full">
                                    <option value="" disabled selected>Seleccionar Idioma</option>
                                    <option>Español</option>
                                    <option>Inglés</option>
                                    <option>Portugués</option>
                                </select>
                            </div>
                            
                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Zona Horaria</label>
                                <select class="w-full">
                                    <option value="" disabled selected>Seleccionar Zona Horaria</option>
                                    <option>(GMT-05:00) Lima</option>
                                    <option>(GMT-05:00) Bogotá</option>
                                    <option>(GMT-04:00) Santiago</option>
                                </select>
                            </div>
                            
                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Moneda</label>
                                <select class="w-full">
                                    <option value="" disabled selected>Seleccionar Moneda</option>
                                    <option>PEN - Sol Peruano</option>
                                    <option>USD - Dólar Estadounidense</option>
                                    <option>COP - Peso Colombiano</option>
                                    <option>CLP - Peso Chileno</option>
                                </select>
                            </div>
                            
                        </div>

                        <!-- Actions -->
                        <div class="mt-8 pt-6 border-t border-slate-200 dark:border-slate-700 flex flex-wrap items-center gap-3">
                            <button 
                                type="button" 
                                @click="saveChanges" 
                                :disabled="isSaving" 
                                class="bg-[#1f8bed] hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold px-6 py-2.5 rounded-lg text-sm transition-colors shadow-sm flex items-center gap-2"
                            >
                                <svg v-if="isSaving" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                                </svg>
                                {{ isSaving ? 'Guardando...' : 'Guardar cambios' }}
                            </button>
                            <button type="button" class="bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 font-medium px-6 py-2.5 rounded-lg text-sm transition-colors">
                                Cancelar
                            </button>
                        </div>
                    </form>
                    
                </div>
            </div>

        </div>
        
        <Alert 
            :show="isAlertShow" 
            :message="alertMessage" 
            type="success"
            @close="isAlertShow = false" 
        />
    </BreezeAuthenticatedLayout>
</template>
